import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import {
  LinearProgress,
  TextField,
  Theme,
  Typography,
  Tooltip,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Autocomplete from '@mui/material/Autocomplete';
import { clientsecretService } from '../ClientSecretService';
import { MessageGroup } from '../Model/ClientSecretesModel';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  typo: {
    padding: '10px',
    fontSize: 12,
  },
}));
export default function AddEditGroup(
  props: Readonly<{
    onclickAdd: Dispatch<SetStateAction<boolean>>;
    addclicked: boolean;
    onClose: () => void;
    clientId: string;
    customerId: string;
  }>,
) {
  const { classes } = useStyles();
  const [groupPageNo, setGroupPageNo] = React.useState(1);
  const { t } = useTranslation('clientsecret');
  const [searchgroupPageNo, setSearchgroupPageNo] = React.useState(1);
  const initialavailablegroups: MessageGroup[] = [];
  const [loading, setLoading] = React.useState(false);
  const initialselectedgroups: MessageGroup[] = [];
  const [canAdd, setCanAdd] = React.useState(false);
  const [searchString, setSearchString] = React.useState<string>();
  const [availableGroupsFlag, setAvailableGroupsFlag] = React.useState(false);
  const [availableGroupsCount, setAvailableGroupsCount] = React.useState(0);

  const [availableGroups, setAvailableGroups] = React.useState<MessageGroup[]>(
    initialavailablegroups,
  );
  const [selectedGroups, setSelectedGroups] = React.useState(
    initialselectedgroups,
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleMouseEnter = () => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 2000);
  };

  const getGroupPageNumber = () => {
    setGroupPageNo(groupPageNo + 1);
    return groupPageNo;
  };
  const getSearchGroupPageNumber = () => {
    setSearchgroupPageNo(searchgroupPageNo + 1);
    return searchgroupPageNo;
  };
  const handleaddGroup = async () => {
    setLoading(true);
    try {
      await clientsecretService
        .addGroupsToClient(props.customerId, props.clientId, selectedGroups)
        .then(() => {
          showToast({
            title: t('clientsecret.success.add_groups'),
            type: 'success',
          });
          props.onClose();
        });
    } catch (error) {
      showToast({
        title: t('clientsecret.error.add_groups'),
        type: 'error',
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchString(event.target.value);
    SearchGroups(event.target.value);
  };
  const loadMoreItems = async () => {
    if (undefined !== searchString) {
      SearchGroups(searchString, getSearchGroupPageNumber());
    }
    setAvailableGroupsFlag(true);
    await clientsecretService
      .getAvailableGroups(
        props.customerId,
        props.clientId,
        getGroupPageNumber(),
      )
      .then((data) => {
        setAvailableGroups((availablegroups) => [
          ...availablegroups,
          ...data.Items,
        ]);
      })
      .then(() => setAvailableGroupsFlag(false));
  };
  const handleValueChange = (newValue: MessageGroup[]) => {
    setSelectedGroups(newValue);
    if (newValue.length > 0) {
      setCanAdd(true);
    } else {
      setCanAdd(false);
    }
  };
  const SearchGroups = async (searchString: string, pageNo = 1) => {
    await clientsecretService
      .searchAvailableGroups(
        props.customerId,
        props.clientId,
        searchString,
        pageNo,
      )
      .then((data) => {
        setAvailableGroups((availablegroups) => [
          ...availablegroups,
          ...data.Items,
        ]);
      });
  };

  async function GetAvailableGroups() {
    setLoading(true);
    setAvailableGroupsFlag(true);
    try {
      await clientsecretService
        .getAvailableGroupsCount(props.customerId, props.clientId)
        .then((availablegroups) => {
          setAvailableGroupsCount(availablegroups);
        });
    } catch (error) {
      showToast({
        title: t((error as Error).message),
        type: 'error',
      });
      console.log(error);
    } finally {
      setLoading(false);
    }

    clientsecretService
      .getAvailableGroups(
        props.customerId,
        props.clientId,
        getGroupPageNumber(),
      )
      .then((data) => {
        setAvailableGroups(data.Items);
      })
      .then(() => setLoading(false))
      .then(() => setAvailableGroupsFlag(false));
  }
  useEffect(() => {
    GetAvailableGroups();
  }, []);
  return (
    <div>
      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}
      {props.addclicked ? (
        <>
          <Typography className={classes.typo}>
            Listing {availableGroups.length} of {availableGroupsCount}
          </Typography>
          <Autocomplete
            multiple
            value={selectedGroups}
            options={availableGroups}
            onChange={(event, newValue) => {
              handleValueChange(newValue);
            }}
            getOptionLabel={(option) => option.Name + ` (${option.Id})`}
            renderInput={(params) => (
              <div className={classes.root}>
                {availableGroupsFlag ? <LinearProgress /> : null}
                <Tooltip
                  open={tooltipOpen}
                  title={t('clientsecret.tooltip.user_group')}
                  arrow
                >
                  <TextField
                    {...params}
                    variant="outlined"
                    onChange={onInputChange}
                    onMouseEnter={handleMouseEnter}
                  />
                </Tooltip>
              </div>
            )}
            ListboxProps={{
              onScroll: (event: React.SyntheticEvent) => {
                const listboxNode = event.currentTarget;
                if (
                  listboxNode.scrollTop + listboxNode.clientHeight ===
                  listboxNode.scrollHeight
                ) {
                  loadMoreItems();
                }
              },
            }}
          />
          {canAdd ? (
            <CustomButton
              startIcon={<AddIcon />}
              onClick={handleaddGroup}
              label="Groups"
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
